import React from 'react';

import { PromoPod } from '../promo-pod/PromoPod';
import { usePromoPresentation } from '../../contexts/PromoPresentationProvider';
import { usePromoCart } from '../../contexts/PromoCartProvider';
import { usePromoModel } from '../../contexts/PromoModelProvider';
import './PromoList.scss';

export const PromoList = () => {
  const { promoListRef, promoListPadding } = usePromoPresentation();
  const { bogoSelectedProduct, freeItemInCart } = usePromoCart();
  const { isBogo, displayableItemIds } = usePromoModel();
  const toBeSelected = bogoSelectedProduct || freeItemInCart;

  return (
    <article
      className="promo-list promo-list--scrollbar"
      data-testid="promo-list"
      ref={promoListRef}
      style={{ paddingTop: promoListPadding }}
    >
      { displayableItemIds.map((itemId, i) => {
        return (
          <PromoPod
            key={itemId}
            itemId={itemId}
            selected={isBogo ? toBeSelected?.itemId === itemId : false}
            displayPosition={String(i + 1)}
          />
        );
      })}
    </article>
  );
};

PromoList.displayName = 'PromoList';
